import type { Project } from "../types";

// R2 연결 시 이 배열 대신 repository 계층의 API 응답을 사용합니다.
export const seedProjects: Project[] = Array.from({ length: 9 }, (_, index) => ({
  id: `project-${index + 1}`,
  title: "내신인강",
  subtitle: "어제 마지막으로 수정 함",
  updatedAt: `${index + 1}시간 전`,
}));
